import classNames from 'classnames';
import type { FunctionComponent } from 'react';
import type { PolicySectionsType } from '.';
import { RichText } from '../../contentful-components/rich-text';
import { checkSubsection } from '../../lib/utils/policy';
import { Text } from '../text';
import styles from './policy-sections.module.scss';
export const PolicySections: FunctionComponent<Props> = ({
  sections
}) => {
  if (sections?.length === 0) {
    return null;
  }
  return <div className={styles['policy-sections']} data-sentry-component="PolicySections" data-sentry-source-file="policy-sections.tsx">
            {sections?.map(section => {
      const isSubsection = checkSubsection(section?.title ?? '');
      return <section id={section.anchor} key={section.anchor} className={classNames(styles['policy-section'], isSubsection && styles['policy-section--subsection'])}>
                        <Text typeStyle='body-lg' bold className={styles['policy-section--title']}>
                            {section.title}
                        </Text>
                        <Text tag='div' typeStyle='body-lg' className={styles['policy-section--content']}>
                            <RichText source={section.content} />
                        </Text>
                    </section>;
    })}
        </div>;
};
export default PolicySections;
interface Props {
  sections?: PolicySectionsType;
}